import { reportFilterSelectionFactory, reportQueryFactory } from 'factories/filter';
import { DateTime } from 'luxon';
import { xhrStatusFactory } from 'redux/reusable/xhrStatus';
import { getSummaryFromTotals } from 'utils/superreports';
import * as hoursTypes from './hours.types';
import type { State } from './superreports.types';
import * as actionTypes from './superreports.types';

export const initialState: State = {
  emailedReport: null,
  draft: {
    widgets: [],
  },
  draftSignature: null,
  query: reportQueryFactory(undefined, {
    weekStartsOn: 0 /* Doesn't matter for pure default values - we'll end up with a month span */,
  }),
  selection: reportFilterSelectionFactory(),
  // report lists
  reportsMaybeHasMore: false,
  reportEntities: {},
  reportResult: [],
  reportFilter: {
    sort_by: 'updated_at',
    order: 'desc',
    limit: actionTypes.ALL_REPORTS_LIMIT,
    offset: 0,
    user_ids: [],
  },
  reportExportSettings: actionTypes.DEFAULT_EXPORT_SETTINGS,
  // public report lists
  publicReportEntities: {},
  publicReportResult: [],
  publicReportFilter: {
    // 'query' for search
    sort_by: 'created_at',
    order: 'desc',
    report_type: 'live',
    userIds: [],
    from: DateTime.now().startOf('month').toISODate(),
    to: DateTime.now().endOf('month').toISODate(),
    span: 'month',
    limit: actionTypes.PUBLIC_REPORTS_LIMIT,
    offset: 0,
  },
  publicReportMaybeHasMore: false,
  publicReportTimestamp: '',
  // report data normalized
  clientDataEntities: {},
  clientDataResult: [],
  labelDataEntities: {},
  labelDataResult: [],
  userDataEntities: {},
  userDataResult: [],
  dayDataEntities: {},
  dayDataResult: [],
  teamDataEntities: {},
  teamDataResult: [],
  linkedWorkDataEntities: {},
  linkedWorkDataResult: [],
  projectDataEntities: {},
  projectDataResult: [],
  reportView: 'grid',
  reportListFilter: 'all',

  timesheetQuery: reportQueryFactory(
    {},
    {
      defaultValues: true,
      weekStartsOn: 0 /* Doesn't matter for pure default values - we'll end up with a month span */,
    }
  ),
  clientReportQuery: reportQueryFactory(
    { filters: { resource: 'client' } },
    {
      defaultValues: true,
      weekStartsOn: 0 /* Doesn't matter for pure default values - we'll end up with a month span */,
    }
  ),
  timesheetColumns: hoursTypes.HOUR_DETAILS_INITIAL_FILTER.columns,
  timesheetTaskColumns: hoursTypes.HOUR_DETAILS_INITIAL_FILTER.taskColumns,
  timesheetTotalCount: 0,
  timesheetMaybeHasMore: false,

  hourSummaryTotalCount: 0,
  hourSummaryMaybeHasMore: false,

  widgetMetadata: {},

  totals: getSummaryFromTotals(),

  xhrStatus: xhrStatusFactory(),

  minimumWidgetWidth: 0,
};
